import { createFileRoute } from '@tanstack/react-router';
import { MeetingTemplateEditorPage } from '@/components/meeting-templates/MeetingTemplateEditorPage.tsx';

export const Route = createFileRoute('/_app/meeting-templates/defaults/$id')({
  staticData: { orgScope: 'none' },
  component: DefaultTemplateRoute,
});

function DefaultTemplateRoute() {
  return <MeetingTemplateEditorPage scope='defaults' templateId={Route.useParams().id} />;
}
